import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import ListSubheader from '@mui/material/ListSubheader'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { GroupedSelectProps } from './SwitchWorkcenter.types'
import { useMemo } from 'react'

export default function GroupedSelect({
  menuItems,
  value,
  handleWorkcenterChange,
}: GroupedSelectProps) {
  // Validate value exists in menu items to prevent uncontrolled/controlled warning
  const validatedValue = useMemo(() => {
    if (!value || !menuItems) return ''

    // Check if current value exists in the menu items
    for (const sourceSite in menuItems) {
      const found = menuItems[sourceSite].find(
        (wc) => String(wc.workCentreKey) === value
      )
      if (found) return value
    }
    return '' // Return empty string if value not found
  }, [value, menuItems])

  const options = useMemo(() => {
    const allOptions = []
    let key = 0
    for (const sourceSite in menuItems) {
      allOptions.push(
        <ListSubheader key={`list-header-key-${key}`}>
          {sourceSite}
        </ListSubheader>
      )
      let subKey = 0
      const workCentres = [...menuItems[sourceSite]].sort((a, b) =>
        a.workCentre.localeCompare(b.workCentre)
      )
      for (const workcenter of workCentres) {
        allOptions.push(
          <MenuItem
            key={`menu-item-${key}-${subKey}`}
            value={workcenter?.workCentreKey}
          >
            {workcenter?.workCentre}
          </MenuItem>
        )
        subKey = subKey + 1
      }
      key = key + 1
    }
    return allOptions
  }, [menuItems])

  return (
    <div>
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel htmlFor="grouped-workcenters-select">Workcenter</InputLabel>
        <Select
          value={validatedValue}
          id="grouped-workcenters"
          label="All workcenters"
          sx={{ height: '40px' }}
          onChange={(e: SelectChangeEvent<string>) =>
            handleWorkcenterChange(e.target.value)
          }
          name="workcenter-select"
        >
          {options}
        </Select>
      </FormControl>
    </div>
  )
}
